import { FieldDefinition, FieldBuilder, MENU_CATEGORY_KEY, MENU_NAME_SUFFIX, MENU_SUBCATEGORY_KEY, MenuCategories, MenuSubcategories } from '@zendra/shared';
import { ProcessService } from '../proxy/controlling/controllers/process.service';
import { IdentityRoleService } from './services/identity-proxy/identity/identity-role.service';

FieldBuilder.setNamespace('Controlling');

export const PROCESSPERPROFILE_FIELDS: FieldDefinition[] = [
  FieldBuilder
    .checkbox('isApprover', 'Entity.ProcessPerProfile.IsApprover')
    .build(),
  FieldBuilder
    .foreignKey('processId', 'Entity.Process', ProcessService)
    .required()
    .displayFromNested('process.name')
    .sortBy('process.name')
    .build(),
  FieldBuilder
    .foreignKey('profileId', 'Entity.ProcessPerProfile.Profile', IdentityRoleService)
    .required()
    .display('name')
    .keyField('id')
    .build(),
];

export const PROCESSPERPROFILE_CONFIG = {
  entityName: 'ProcessPerProfile',
  localizationKey: 'Controlling::Entity.ProcessPerProfile',
  fields: PROCESSPERPROFILE_FIELDS,
  permission: 'ControllingActivities.ProcessPerProfiles',
  showInMenu: true,
  menuCategory: MENU_CATEGORY_KEY + MenuCategories.Controlling + MENU_NAME_SUFFIX,
  menuSubcategory: MENU_SUBCATEGORY_KEY + MenuSubcategories.Activities + MENU_NAME_SUFFIX,
};
